/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.phone-badge-check\":\"Älypuhelin ja valintamerkki\"}");